module.exports = __webpack_public_path__ + "static/media/parapharmacie.a7a9fd19.webp";